<div class="flex items-center justify-center w-full banner bg-center bg-cover" style="background-image: url({{this.headerImage}});">
  <div class="flex max:w-2/3 justify-center items-center flex-col p-4">
    <h1 [style.color]="headerTextColor" class="text-center md:text-6xl font-bold text-4xl max-sm:text-left">
      {{headerTitle}}
    </h1>
    <!-- <button class="w-full md:w-1/3 fuse-mat-button-small mt-6 text-lg font-bold" mat-flat-button [color]="'accent'"
      [routerLink]='["/contact-us"]'>
      Contact us
    </button> -->
  </div>
</div>

    <!-- <div class=" w-full bg-[#d5d4d9] p-8">
      <h1 class="md:text-4xl text-2xl font-medium text-black p-3 text-center ">
        Don’t hear it from us! Hear it from your fellow South Africans who voted us 2nd best ISP for speed and service delivery in 2023.
      </h1>
    </div> -->

  <section class="md:block hidden">
    <div class="flex justify-center my-16" *ngFor="let item of aboutUs; let i = index">
      <ng-container *ngIf="i % 2 === 0; else oddItem">
        <!-- Even indexed item, image on the left, text on the right -->
        <div class="flex-row w-1/3 mr-16">
          <h1 class="text-4xl font-medium">{{ item.title }}</h1>
          <p class="text-xl" [innerHtml]="item.description | innerHTMLPipe"></p>
        </div>
        <div class="flex-row w-1/4">
          <img [src]="item.image[0].url" alt="{{item.image[0].url}}" class="rounded-lg" loading="lazy">
        </div>
      </ng-container>
      <ng-template #oddItem>
        <!-- Odd indexed item, text on the left, image on the right -->
        <div class="flex-row w-1/4">
          <img [src]="item.image[0].url"  alt="{{item.image[0].url}}" class="rounded-lg" loading="lazy">
        </div>
        <div class="flex-row w-1/3 ml-16">
          <h1 class="text-4xl font-medium">{{ item.title }}</h1>
          <p class="text-xl" [innerHtml]="item.description | innerHTMLPipe"></p>
        </div>
      </ng-template>
    </div>
  </section>
  <section class="md:hidden block">
    <div class="flex flex-col items-center my-8 mx-8">
      <div *ngFor="let item of aboutUs; let i = index" class="flex flex-col mb-12">
        <div class="w-full">
          <h1 class="text-4xl font-medium">{{ item.title }}</h1>
          <p class="text-xl" [innerHtml]="item.description | innerHTMLPipe"></p>
        </div>
        <div class="w-full mt-10">
          <img [src]="item.image[0].url" alt="{{item.image[0].url}}" class="rounded-lg" loading="lazy">
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class=" w-full  bg-[#d5d4d9] p-8 flex flex-col  items-center">
      <h1 class="text-4xl font-bold text-black  ">
        Contact us
      </h1>
      <p class="text-center text-2xl">
        If you need help, please get in touch.
      </p>
      <button class="fuse-mat-button-large mt-6 text-xl" [routerLink]='["/contact-us"]' mat-flat-button
        [color]="'accent'">
        Contact us
      </button>
    </div>
  </section>
